import axiosInstance from "@/api/axios-instance";

export async function getIndividialSessionSchedulingLink({
  couples_pack_usage_identifier
}: {
  couples_pack_usage_identifier: string;
}) {
  const response = await axiosInstance.get("/couples-packs/individual-session-link", {
    params: { couples_pack_usage_identifier },
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to get scheduling link");
  }

  const { success, schedulingLink, errorMessage } = response.data;

  if (!success) {
    throw new Error(errorMessage || "Failed to get scheduling link");
  }
  return schedulingLink;

}
